import { Injectable } from '@angular/core';
import { SEARCH_BASE_URL } from '@capital-access/search/common';

@Injectable({ providedIn: 'root' })
export class UrlBuilder {
  getUrl(url: string) {
    return `${SEARCH_BASE_URL}/${url}`;
  }
}
